














import Home from './scripts';
export default Home;
